import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import './ForgotPasswordForm.scss'
import { HttpService } from 'services/HttpService';
import { TokenService } from 'services/TokenService';
import MessageBox from 'components/MessageBox/MessageBox';
import CircleLoader from 'components/CircleLoader/CircleLoader';

export class ForgotPasswordFormComponent extends Component {

  messageBox = {
    title: "Login Failed",
    message: "Check your Email and enter the verification code to reset your Password.",
    color: "danger",
    icon: "error"
  }

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onEmailChange = this.onEmailChange.bind(this);
    this.onSuccessRequest = this.onSuccessRequest.bind(this);
    this.onMessageClose = this.onMessageClose.bind(this);
    this.state = {
      email: '',
      loaderIsActive: false,
      showMessageBox: false
    };
  }

  componentDidMount() {
    this.setState({ email: this.props.email });
  }

  onEmailChange(email) {
    this.setState({email: email})
  }

  onMessageClose(event) {
    this.setState({ showMessageBox: false });
  }

  handleSubmit(event) {
    this.setState({loaderIsActive: true})
    this.messageBox.isActive = false;
    const host = process.env.REACT_APP_SERVER;
    const body = {
      "email": this.state.email,
    };

    new HttpService().sendRequest(`${host}/api/users/forgetPassword`,{
      body: JSON.stringify(body),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((result) => {
      console.log("Got result");
      this.messageBox.message = result.response;

      if (result.res) {
        this.messageBox.title = 'Request Successful';
        this.messageBox.color = 'primary';
      } else {
        this.messageBox.title = 'Request Failed';
        this.messageBox.color = 'danger';
      }

      this.setState({ loaderIsActive: false, showMessageBox: true });
    })
    .catch((err) => {
      this.messageBox.title = 'Request Failed';
      this.messageBox.message = err;
      this.messageBox.color = 'danger';
      this.setState({ loaderIsActive: false, showMessageBox: true });
    });
    event.preventDefault();
  }

  onSuccessRequest(result) {
    const tokenService = new TokenService();
    tokenService.saveToken(result.token);

    this.props.onSubmit({ result: 'success' });
  }

  render() {
    const { email, loaderIsActive, showMessageBox } = this.state;

    return (
      <form className="o-forgot-password-form" onSubmit={this.handleSubmit}>
        <h1 className="o-forgot-password-form__title">Forgot password?</h1>
        <p className="o-forgot-password-form__subtitle">
          We'll send a reset link to your e-mail. Please type your e-mail address below.
        </p>

        <div className="o-forgot-password-form__field">
          <label className="o-forgot-password-form__label" htmlFor="forgot-email">Email Address</label>
          <div className="o-forgot-password-form__input-box">
            <i className="material-icons">mail_outline</i>
            <input
              id="forgot-email"
              className="o-forgot-password-form__input"
              type="email"
              autoComplete="email"
              placeholder="name@company.com"
              value={email || ''}
              onChange={(event) => this.onEmailChange(event.target.value)}
              required
            />
          </div>
        </div>

        {
          !loaderIsActive ?
          <button className="o-forgot-password-form__submit" type="submit" value="Submit">
            <span>Send reset link</span>
          </button>
          : <CircleLoader isActive={loaderIsActive} />
        }

        <div className="o-forgot-password-form__back">
          <span>Remembered it?</span>
          <Link to="/login">
            Back to log in
            <i className="material-icons">arrow_forward</i>
          </Link>
        </div>

        {
          showMessageBox ?
          <MessageBox {...this.messageBox} onClose={this.onMessageClose} />
          : ''
        }
      </form>
    )
  }
}

export default ForgotPasswordFormComponent
